export const INK = "#16252e";
export const MUTED = "#6c7884";
export const FAINT = "#9aa6b0";
export const HAIR = "#e6ebf0";
export const GRID = "#eef2f6";
export const TEAL = "#0081af";
export const SKY = "#00abe7";
export const ORANGE = "#f7941d";
export const DEEP = "#005f80";
export const POS = "#1f9d6b";
export const NEG = "#d2603a";
export const GOLD = "#d99a32";
export const PAGE_BG = "#eaeef3";
export const CARD = "#ffffff";
export const CARD_SHADOW = "0 1px 2px rgba(20,40,55,.04)";

export const GOAL_PCT = 12.0;
export const VOLUME_GOAL = 25000;
export const ET = "America/New_York";

export function etTodayDate() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: ET }).format(new Date());
}

export function etYesterdayRange() {
  const str = etTodayDate();
  const [y, m, d] = str.split("-").map(Number);
  const yesterday = new Date(Date.UTC(y!, m! - 1, d! - 1)).toISOString().slice(0, 10);
  return { start: `${yesterday}T00:00`, end: `${yesterday}T23:59` };
}

export function fmtInt(n: number) {
  return Math.round(n).toLocaleString();
}
export function fmtPct(n: number) {
  return `${Number(n).toFixed(1)}%`;
}
export function fmtDuration(sec: number) {
  const s = Math.round(sec);
  const m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  if (h) return `${h}h ${m % 60}m ${s % 60}s`;
  if (m) return `${m}m ${s % 60}s`;
  return `${s}s`;
}
export function pct(n: number, d: number) {
  return d === 0 ? 0 : (100 * n) / d;
}
export function fmtDateLabel(dateStr: string) {
  return new Date(`${dateStr}T12:00:00`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}
